/* eslint-disable */
import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";


/**
 * 根据输入的类型调用函数
 * @param pageNum
 * @param type
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export function Listyy(
    pageNum,
    type
) {
    if (type == 1) {
        return getPerformanceList({pageNum})
    } else {
        return getSettleList({pageNum})
    }
}


/**
 * 获取正在履约数据
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getPerformanceList({
                                       pageNum
                                   }) {
    return axios.get(api + "/finance/getPerformanceList", {
        params: {
            pageNum
        }
    })
}

/**
 * 获取结算数据
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getSettleList({
                                  pageNum
                              }) {
    return axios.get(api + "/finance/getSettleList", {
        params: {
            pageNum
        }
    })
}

/**
 * 查询失信
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getLetterLose(
    pageNum
) {
    return axios.get(api + "/finance/getLetterLose", {
        params: {
            pageNum
        }
    })
}

/**
 * 结算
 * @param finenceId
 * @param lendLoanAmout
 * @param lendRateAmout
 * @param evaluation
 * @param letterTime
 * @param lostLetterRemark
 * @returns {AxiosPromise<any>}
 */
export function insertFinenceSettle({
                                        financeId,
                                        loanId,
                                        lendLoanAmout,
                                        lendRateAmout,
                                        evaluation,
                                        letterStatus,
                                        lendTime,
                                        lostLetterRemark
                                    }) {
    return axios.post(api + "/finance/addSettle", {
        financeId,
        loanId,
        lendLoanAmout,
        lendRateAmout,
        evaluation,
        letterStatus,
        lendTime,
        lostLetterRemark
    })
}

/**
 * 结算
 * @param finenceId
 * @param lendLoanAmout
 * @param lendRateAmout
 * @param evaluation
 * @param letterTime
 * @param lostLetterRemark
 * @returns {AxiosPromise<any>}
 */
export function getListSearch({
                                  companyName,
                                  productName,
                                  type,
                                  pageNum,
                                  pageSize,
                                  patterType,startTime,endTime,manager
                              }) {
    return axios.get(api + "/finance/getListSearch", {
        params: {
            companyName,
            productName,
            type,
            pageNum,
            pageSize,
            patterType,startTime,endTime,manager
        }
    })
}

/**
 * 首页搜素产品信息
 * @param productName   产品名称
 * @param pageNum       页码
 * @param pageSize      每页显示数量
 * @returns {AxiosPromise<any>}
 */
export function indexFindAll({
                                 financeName,
                                 productName,
                                 financeType,
                                 guarantee,
                                 loanMax,
                                 loanMin,
                                 loanDeadline,
                                 loanLimit,
                                 pageNum,
                                 pageSize
                             }) {
    return axios.get(api + "/finproinfo/indexFind", {
        params: {
            financeName,
            productName,
            financeType,
            guarantee,
            loanLimit,
            loanMax,
            loanMin,
            loanDeadline,
            pageNum,
            pageSize
        }
    })
}

/**
 * 获取单个产品信息
 * @param id 产品主键
 * @returns {AxiosPromise<any>}
 */
export function indexFindById({
                                  id
                              }) {
    return axios.get(api + "/finproinfo/indexFindById", {
        params: {
            id
        }
    })
}
/**
 * 获取列表统计信息
 */
export function getCountObj(companyName,
                            productName,
                            patterType,startTime,endTime,manager) {
    return axios.post(api + "/finance/getCountObj",qs.stringify({
        companyName,
        productName,
        patterType,startTime,endTime,manager
    }))
}
/**
 *
 * @param financeProduct
 * @returns {AxiosPromise<any>}
 */
export function checkApply(financeProduct) {

    return axios.post(api + "/finproinfo/checkApply", {
        financeProduct
    })
}

/**
 * 获取产品保证类型
 */
export function getGuarantee() {
    return axios.get(api + "/finproinfo/getInit",)
}
/**
 * 获取授权同意书内容
 */
export function getSqtys() {
    return axios.get(api + "/xydaSelect/authorization")
}
/**
 * 查询产品
 * @returns {AxiosPromise<any>}
 */
export function search(conditions) {
    return axios.post(api + "/finproinfo/search", conditions);
}

/**
 * 添加在线留言
 * @param conditions
 * @returns {AxiosPromise<any>}
 */
export function addOnlineMessage(data) {
    return axios.post(api + "/onlineMessage/addOnlineMessage", data);
}

/**
 * 获取留言列表
 * @returns {AxiosPromise<any>}
 */
export function getOnlineMessageList(companyName,themeName,pageNum,pageSize) {
    return axios.get(api + "/onlineMessage/getOnlineMessageList", {
        params:{
            companyName,
            themeName,
            pageNum,
            pageSize
        }
    });
}

/**
 * 查询热门产品
 * @returns {AxiosPromise<any>}
 */
export function getHotPros() {
    return axios.post(api + "/finproinfo/getHotPros");
}
/**
 * 查询成功案例
 * @returns {AxiosPromise<any>}
 */
export function getSuccessList(id) {
    return axios.get(api + "/finproinfo/getSuccessList", {
        params: {
            id
        }
    });
}

/**
 * 获取首页所需金融信息
 * @returns {AxiosPromise<any>}
 */
export function getIndexData() {
    return axios.get(api + "/finproinfo/getIndexData",);
}


/**
 * 获取企业用户的工作台数据和融资订单数据
 * @returns {AxiosPromise<any>}
 */
export function getEnterprise(){
    return axios.get(api+"/finance/enterprise");

}
export function getOrganization(){
    return axios.get(api+"/finance/organization");

}

export function getMonth(year){
    return axios.get(api+"/finance/month",{
        params:{
            year
        },
    })
}

export function findOnProId(companyName, proId) {
    return axios.get(api + "/finance/findOnProId", {
        params: {
            companyName, proId
        }
    });
}

export function getGovernment(){
    return axios.get(api+"/finance/government")
}
export function getTotol(){
    return axios.get(api+"/finance/getTotol")
}
export function getLast50(){
    return axios.get(api+"/finance/getLast50")
}
export function getMonthGov(year){
    return axios.get(api+"/finance/monthGov",{
        params:{
            year
        },
    })
}
export function getBaankCharDate(year){
    return axios.get(api+"/finance/getBankCharDate",{
        params:{
            year
        },
    })
}
export function getmapGov(){
    return axios.get(api+"/finance/mapGov")
}

export function getRankGov(type,year){
    return axios.get(api+"/finance/rankGov",
    {
        params:{
            type,
            year
        },
    }
    )
}

export function getUnread(){
    return axios.get(api+"/finance/unReaded")
}



/**
 * 查询所属企业列表
 * @returns {AxiosPromise<any>}
 */
export function getCompanyList(id) {
    return axios.get(api + "/finance/getCompanyList", {
        params: {
            id
        }
    });
}



export function getDataOrg(){
    return axios.get(api+"/finance/getDataOrg")
}

export function getExcle(){
    return axios.get(api+"/finance/getExcle"
)
}


export function getCondition(start,end){
    return axios.get(api+"/finance/getCondition",{
        params:{
            start,
            end
        }
    })
}

/**
 * 获取成功案例
 * @returns {AxiosPromise<any>}
 */
export function getSuccessfulCases(){
    return axios.get(api+"/finance/getSuccessfulCases",{})
}

/**
 * 获取需求发布前50条
 * @returns {AxiosPromise<any>}
 */
export function getDemandRelease(){
    return axios.get(api+"/finance/getDemandRelease",{})
}

/**
 * 获取金融机构列表
 * @param conditions 筛选条件
 * @returns {AxiosPromise<any>} 结果
 */
export function listMechanismInfo(conditions) {
    return axios.post(api + "/financialInstitution/listMechanismInfo", conditions);
}

/**
 * 获取机构列表图片显示
 * @param conditions
 * @returns {AxiosPromise<any>}
 */
export function listMechanismInfoByImage(data) {
    return axios.post(api + "/financialInstitution/listMechanismInfoByImage", data);
}

/**
 * 根据param获取字典数据
 * @param {Object} mark
 */
export function getTypes(mark) {
    return axios.get(api + "/sysParam/select", {
        params: {
            mark
        }
    })
}
/**
 * 获取银行账户所属的金融产品
 * 根据YxdwId是否为空判断，不为空即满足条件
 * @returns 产品信息
 */
 export function getBankProduct(type){
    return axios.get(api + "/finance/getBankProduct",{
        params:{
            type
        }
    });
}
/**
 * 获取客户经理
 */
export function getYxdwUser(){
    return axios.post(api + "/finance/getYxdwUser");
}
/**
 *派单
 */
export function updateYxdwUser(id,yxdwUserId) {

    return axios.post(api + "/finance/updateYxdwUser", qs.stringify({
        id,yxdwUserId
    }))
}
/**
 * 授信排行
 * @returns {AxiosPromise<any>}
 */
export function indexRank(){
    return axios.get(api+"/finance/indexRank",{})
}

/**
 * 金融平台数据统计
 */
export function findByLogindept(logindept=null, startTime=null, endTime=null) {
    return axios.get(api + "/finance/findByLogindept", {
        params: {
            logindept, startTime, endTime
        }
    })
}

/**
 * 金融平台数据统计导出
 */
export function exportExcel(logindept=null, startTime=null, endTime=null) {
    return axios.get(api + "/finance/exportExcel", {
        params: {
            logindept, startTime, endTime
        },
        responseType:'blob'
    })
}

export function findByLogindept2(startTime=null, endTime=null) {
    return axios.get(api + "/finance/findByLogindept2", {
        params: {
            startTime, endTime
        }
    })
}
export function groupByYxdwUserId({startTime, endTime}) {
    return axios.get(api + "/finance/groupByYxdwUserId", {
        params: {
            startTime, endTime
        }
    })
}
